import { BRAND_NAME } from 'lib/constants/organization';
import type { WebSite, WithContext } from 'schema-dts';
import { getBaseUrl } from 'utils/getBaseUrl';

import { orgId, websiteId } from './helpers/ids';

// NOTE: potentialAction (SearchAction) is intentionally omitted until a
// crawlable /search results URL exists. Site search is currently a modal.
export const buildWebSite = (): WithContext<WebSite> => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': websiteId(),
  url: getBaseUrl(),
  name: BRAND_NAME,
  publisher: { '@id': orgId() },
});
